import { buildFacetManager, buildFacet, Facet, FacetManager, SearchEngine } from '@coveo/headless';
import sitesHeadlessEngine from './sitesHeadlessEngine';

export interface SitesHeadlessFacets {
  facetManager: FacetManager;
  siteStateFacet: Facet;
  siteStateCodeFacet: Facet;
  siteRelatedConditionsFacet: Facet;
  siteRelatedCommunitiesFacet: Facet;
  siteLanguagesFacet: Facet;
  siteStatusFacet: Facet;
  siteRecruitingTypeFacet: Facet;
  sitePhaseFacet: Facet;
}

export const buildSitesHeadlessFacets = (
  // eslint-disable-next-line @typescript-eslint/ban-types
  engine: SearchEngine<{}>
): SitesHeadlessFacets => ({
  facetManager: buildFacetManager(engine),
  siteStateFacet: buildFacet(engine, { options: { field: 'site_state' } }),
  siteStateCodeFacet: buildFacet(engine, { options: { field: 'site_statecode' } }),
  siteRelatedConditionsFacet: buildFacet(engine, { options: { field: 'site_relatedconditions' } }),
  siteRelatedCommunitiesFacet: buildFacet(engine, {
    options: { field: 'site_relatedcommunities' },
  }),
  siteLanguagesFacet: buildFacet(engine, { options: { field: 'site_languages' } }),
  siteStatusFacet: buildFacet(engine, { options: { field: 'site_status' } }),
  siteRecruitingTypeFacet: buildFacet(engine, { options: { field: 'site_recruitingtype' } }),
  sitePhaseFacet: buildFacet(engine, { options: { field: 'site_phase' } }),
});

let cachedFacets: SitesHeadlessFacets | null = null;

/** Lazily builds and caches facets for the default sites engine. Client-side only. */
export const getSitesHeadlessFacets = (): SitesHeadlessFacets => {
  if (typeof window === 'undefined') {
    throw new Error('Sites headless facets must be initialized on the client');
  }

  if (!cachedFacets) {
    cachedFacets = buildSitesHeadlessFacets(sitesHeadlessEngine);
  }

  return cachedFacets;
};
